export default class NetworkError extends Error {
	public constructor() {
		super();
	}
}
